import { render, staticRenderFns } from "./StoreProductTypeForm.vue?vue&type=template&id=13e122af"
import script from "./StoreProductTypeForm.vue?vue&type=script&lang=js"
export * from "./StoreProductTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports